import { render, staticRenderFns } from "./users-select.vue?vue&type=template&id=16bcb2c2&scoped=true&"
import script from "./users-select.vue?vue&type=script&lang=js&"
export * from "./users-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16bcb2c2",
  null
  
)

export default component.exports